// src/colors.ts
var colors = {
  black: "#000000",
  grey90: "#181818",
  grey80: "#333333",
  grey60: "#585858",
  grey45: "#8c8c8c",
  grey30: "#b2b2b2",
  grey15: "#d9d9d9",
  grey10: "#e5e5e5",
  grey05: "#f2f2f2",
  white: "#ffffff",
  bsR\u00F8dDark: "#870010",
  bsR\u00F8dMedium: "#d53d40",
  accentPurple: "#331433",
  accentPeach: "#ffba99",
  accentGreen: "#003b29",
  accentBlueDark: "#001740",
  accentBlueMedium: "#5996de",
  accentYellow: "#ffc970",
  lightBlue: "#dbe8ef",
  lightGreen: "#dbe0db",
  lightPeach: "#f4e7de",
  lightPurple: "#ece8f3",
  statusRed: "#ad313c",
  statusYellow: "#bc5600",
  statusGreen: "#24845b",
  statusGreenLight: "#edf4f1",
  statusRedLight: "#f8efef",
  statusYellowLight: "#fff6e4",
  neptune: {
    "100": "#CFE6E8",
    "200": "#9FCDD2",
    "300": "#6FB5BB",
    "400": "#3F9CA5",
    "500": "#0F838E",
    "600": "#0C6972",
    "700": "#094F55",
    "800": "#063439",
    "900": "#031A1C"
  }
};

// src/date.ts
import { format } from "date-fns/format";
import { nb } from "date-fns/locale/nb";
function formaterDato(dato, dateFnsformat = "Pp") {
  if (typeof dato !== "string")
    return "Ukjent dato";
  try {
    return format(new Date(dato), dateFnsformat, { locale: nb });
  } catch (e) {
    console.error("Kunne ikke formattere dato:" + dato, e);
    return dato;
  }
}

// src/environment.ts
function isDevelopment() {
  return process.env.NODE_ENV === "development";
}
function isClient() {
  return typeof window !== "undefined";
}
function isServer() {
  return !isClient();
}

// src/random.ts
function randomFromArray(array) {
  return array[Math.floor(Math.random() * array.length)];
}
function seededRandomFromArray(array, seed) {
  return array[Math.floor(seededRandom(seed) * array.length)];
}
function seededRandom(seed) {
  const numericSeed = Number(seed.replace(/\D/g, (match) => `${match.charCodeAt(0)}`));
  const x = Math.sin(numericSeed) * 3333;
  return x - Math.floor(x);
}

// src/slugifyString.ts
var slugifyString = (value = "") => value.trim().toLowerCase().replace(/æ/g, "ae").replace(/å/g, "a").replace(/ø/g, "o").replace(/\W/g, "-").replace(/-+/g, "-").slice(0, 30);

// src/sort/common.ts
var compareAlphabetically = (left, right) => left.localeCompare(right, ["no-NO"]);
var compare = (left, right, indexFunction) => {
  const leftIndex = indexFunction ? indexFunction(left) : left;
  const rightIndex = indexFunction ? indexFunction(right) : right;
  if (typeof leftIndex == "number" && typeof rightIndex == "number")
    return leftIndex - rightIndex;
  if (typeof leftIndex == "string" && typeof rightIndex == "string") {
    return compareAlphabetically(leftIndex, rightIndex);
  }
  throw new Error("Sort index function gives inconsistent index types");
};

// src/sort/sortAlphabetical.ts
var sortAlphabetical = (array, indexFunction) => array.slice().sort((left, right) => compare(left, right, indexFunction));

// src/sort/sortArrayInGroups.ts
function sortArrayInGroups(items, getGroupLabel, options) {
  const groups = items.reduce((acc, arrayEntry) => {
    const currentCategory = getGroupLabel(arrayEntry);
    const categoryIndex = acc.findIndex((group) => group.label === currentCategory);
    if (categoryIndex >= 0) {
      acc[categoryIndex].items.push(arrayEntry);
    } else {
      acc.push({
        label: currentCategory,
        items: [arrayEntry]
      });
    }
    return acc;
  }, []);
  return options?.sortAlphabetically ? groups.sort(sortByLabel) : groups;
}
function sortByLabel(a, b) {
  if (a.label.toLowerCase() > b.label.toLowerCase())
    return 1;
  if (a.label.toLowerCase() < b.label.toLowerCase())
    return -1;
  return 0;
}

// src/sort/sortByMultiple.ts
var sortByMultiple = (array, ...indexFunctions) => array.slice().sort(
  (left, right) => indexFunctions.slice(1).reduce(
    // If the previous comparison is 0, it means left and right are equal according to the previous
    // comparison function. That's also the only way it'll be falsy, therefore we can
    // use the or operator || to then apply the next comparison function.
    (previous, indexFunction) => previous || compare(left, right, indexFunction),
    compare(left, right, indexFunctions[0])
    // Initial comparison
  )
);
export {
  colors,
  formaterDato,
  isClient,
  isDevelopment,
  isServer,
  randomFromArray,
  seededRandom,
  seededRandomFromArray,
  slugifyString,
  sortAlphabetical,
  sortArrayInGroups,
  sortByMultiple
};
//# sourceMappingURL=index.mjs.map